import { keyframes, styled, css, useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { fade } from '@vebox/etui-colors';
import { S as SpinnerSize, g as getSpinnerSize } from '../utils-fabc7ae7.js';

const _excluded = ["size", "color", "isInline"];
const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const SpinnerCircleDiv = styled(Div).attrs(_ref => {
  let {
      size,
      color,
      isInline
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    width: size,
    height: size,
    borderColor: fade(color, 0.25),
    m: isInline ? 'unset' : 'auto auto'
  }, rest);
})`
  box-sizing: border-box;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.53, 0.21, 0.29, 0.67);
  border-radius: 50%;
  border-width: 1.5px;
  border-style: solid;
  border-image: initial;

  ${({
  stopAnimation,
  color
}) => css`
    border-top-color: ${!stopAnimation ? color : fade(color, 0.25)};
    animation-name: ${stopAnimation ? 'unset' : spinAnimation};
  `};
`;

const _excluded$1 = ["size", "theme", "color"];
const getSpinnerLabelFontSize = (size, theme) => {
  switch (size) {
    case SpinnerSize.xSmall:
    case SpinnerSize.small:
      return theme.typography.fontSizeSmall;
    default:
      return theme.typography.fontSizeBase;
  }
};
const SpinnerTextDiv = styled(Div).attrs(_ref => {
  let {
      size,
      theme,
      color
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2({
    fontSize: getSpinnerLabelFontSize(size, theme),
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: theme.typography.lineHeightBase,
    color: color || theme.palette.success.main,
    mt: `${theme.spacing.sm}px`,
    width: 'unset',
    height: 'unset'
  }, rest);
})`
  text-align: center;
`;

const Spinner = ({
  label,
  size = SpinnerSize.medium,
  stopAnimation = false,
  isTransparent = false,
  isInline = false,
  styles = {},
  color
}) => {
  const theme = useTheme();
  const spinnerColor = color || (isTransparent ? theme.palette.common.white : theme.palette.success.main);
  return /*#__PURE__*/createElement(Div, _extends({
    testId: "spinner-wrapper"
  }, styles.root), /*#__PURE__*/createElement(SpinnerCircleDiv, _extends({
    size: getSpinnerSize(size),
    stopAnimation: stopAnimation,
    isInline: isInline,
    color: spinnerColor
  }, styles === null || styles === void 0 ? void 0 : styles.circle)), label && /*#__PURE__*/createElement(SpinnerTextDiv, _extends({
    size: size,
    color: color
  }, styles.label), label));
};

export default Spinner;
